export default __webpack_public_path__ + "static/media/icon-logo-appgallery.98c93729.png";